import styled from 'styled-components';

import { blue, fontSize, placeholderGray } from '../../styles/variables';

export const IconWrapper = styled.div`
  display: flow-root;
  margin-top: -32px;
  width: 24px;
`;

export const InputIconWrapper = styled.div`
  width: 100%;
`;

export const StyledLink = styled.a`
  color: ${placeholderGray};
  display: flex;
  align-items: center;
  &:active,
  &:visited,
  &:focus,
  &:hover {
    text-decoration: none;
  }
  &:hover {
    color: ${blue};
  }
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export const CounterWrapper = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  justify-content: flex-end;
  color: ${placeholderGray};
  font-size: ${fontSize};
  margin-top: 4px;
`;
